import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export { ANALYTICS_SOURCE } from '../src/BulkAccessManagementPage.tsx';

export const BulkAccessManagementPage: LoadableType<Omit<unknown, 'flags'>> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkAccessManagementPage" */ '../src/BulkAccessManagementPage.tsx'
			)
		).BulkAccessManagementPage,
	name: 'BulkAccessManagementPage',
});
